import React, { Component }  from "react";
import { Button, Glyphicon } from "react-bootstrap";
import { FontAwesomeIcon }   from '@fortawesome/react-fontawesome'
import LoaderButton          from "../../components/LoaderButton";
import { WhiteLabel }        from "../../utils/WhiteLabelProps";

var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;

export default class WorkoutFinishedBox extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount () {
    }
    
    render() {

        return  <div>

                    <div style={{float:"left", position:"fixed", top:0, left:0, opacity:.4,  width:"100%", height: "100%", backgroundColor:"#333", zIndex:10}}
                         onClick={ this.props.handleHideOverlay}
                    />

                        <div style={{textAlign:"center", position:"absolute", color:"white", cursor: "pointer", zIndex:1100}}>
                            <div style={{width: 400, textAlign:"center", padding: 15, fontSize: 24, color: this.props.color}}>

                                <div style={{float: "right", color:"#eee", cursor: "pointer", fontSize:16, position: "relative", top:-50, right: -20}}
                                      onClick={ this.props.handleHideOverlay}>
                                      <FontAwesomeIcon icon="times-circle" style={{ color: "#999", fontSize:25 }}/>
                                </div>
                                <div style={{position: "relative", top:-5, left: 23}}>
                                    <FontAwesomeIcon icon="thumbs-up" style={{ position:"relative", top:"0px", fontSize:45 }}/>
                                </div>
                                <div style={{width:386, border:"0px solid #000"}}>
                                        Good job on your workout!<br/>
                                        <div style={{position:"relative", left:52, width:270, textAlign:"center", fontSize:18, border: "0px solid #000"}}>
                                        To save your progress, view the Workout Summary.
                                        </div>
                                </div>
                            </div>
                            <div style={{display: "inline-block", width: "100%", textAlign:"center"}}>
                                <LoaderButton
                                  width     = "220px"
                                  height    = "40px"
                                  fontSize  = "17px"
                                  type      = "submit"
                                  btncolor  = { MainColor }
                                  isLoading = {this.props.isLoading}
                                  onClick   = {this.props.handleWorkoutFinished}
                                  text      = "Workout Summary"
                                  loadingText=""
                               />
                           </div>
                           <br/><br/><br/>
                      </div>
              </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/workout/WorkoutFinishedBox.js